import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'nio-success-modal',
    templateUrl: './success-modal.component.html',
    styleUrls: ['./success-modal.component.scss'],
    standalone: false
})
export class SuccessModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SuccessModalComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  noClick(isExit: boolean | string = false): void {
    this.dialogRef.close(isExit);
  }
}
